<script>

export default {
    name: 'dkbr-title',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        name: {
            name: 'name',
            type: String,
            txtDescr: `Icon name`,
            default: _ => 'menu',
        },
        size: {
            name: 'size',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: `Icon size`,
            default: _ => 1,
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: `Text near icon`,
            default: _ => '',
        },
        textDir: {
            name: 'textDir',
            type: String,
            enum: ['right', 'left'],
            txtDescr: `Text position relative to icon`,
            default: _ => 'right',
        },
        source: {
            name: 'source',
            type: String,
            enum: ['gg', 'fa'],
            txtDescr: `Icon source (google, font-awesome, etc.)`,
            default: _ => 'gg',
        },
    }
}
</script>

<template lang="pug">

div.dkbr-icon
    span.dkbr-icon_text(
        v-if="text"
        :class=`['dkbr-icon__text_'+textDir]`
        v-html="text")
    md-icon.dkbr-icon_icon(
        :md-theme="isThInv ? th+'i' : th"
        :class=`[
            'md-primary',
            'md-size-'+size+'x',
            source == 'fa' ? 'fa' : undefined,
            source == 'fa' ? 'fa-'+name : undefined]`)
            | {{ source == 'gg' ? name : undefined }}
</template>

<style lang="sass">

@import '~@/sass/root.sass'

.dkbr-icon
    display: inline-block
    +flex(row, nowrap, flex-start, center)
    &__icon, .md-icon
        order: 0
        +margin(0)
        +padding(0)
    &__text
        &_right
            order: 1
            +padding-l(15px)
        &_left
            order: -1
            +padding-r(15px)
</style>



// WEBPACK FOOTER //
// src/title/vue/Title.vue